var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoIcon = function SvgLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.999,
    height: 39.891
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 577",
    transform: "translate(-937.001 -196.555)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.9,
    height: 47.557,
    fill: "#003566",
    "data-name": "Rectangle 518",
    rx: 3.95,
    transform: "rotate(74.7 363.729 753.414)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.9,
    height: 47.557,
    fill: "#f7a539",
    "data-name": "Rectangle 519",
    rx: 3.95,
    transform: "rotate(74.7 362.494 741.876)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003566",
    d: "M989.31 220.09a3.95 3.95 0 0 1-2.768 4.855l-38.27 10.47a3.95 3.95 0 0 1-4.854-2.77 3.95 3.95 0 0 1 2.77-4.854l38.268-10.47a3.95 3.95 0 0 1 4.855 2.77",
    "data-name": "Path 562"
  }))));
};
export default SvgLogoIcon;